import { assignClinicianAsync } from "api/customers";
import { useGlobalToast } from "components/GlobalToastProvider";
import { useMutation } from "react-query";

const useAssignClinician = (options = {}) => {
  const { onError = () => {}, ...otherOptions } = options;
  const { showToast } = useGlobalToast();

  const { mutate, mutateAsync, isLoading, ...rest } = useMutation(
    ({ clientId, clinicianUserId }) => assignClinicianAsync(clientId, clinicianUserId),
    {
      onError: () => {
        showToast({
          message: "Error assigning the clinician",
          errorState: true,
        });
        onError();
      },
      ...otherOptions,
    }
  );

  return {
    assignClinician: mutate,
    assignClinicianAsync: mutateAsync,
    isAssignClinicianLoading: isLoading,
    ...rest,
  };
};

export default useAssignClinician;
